import { useMemo } from "react";

import DOMPurify from "dompurify";

import Text from "src/components/text";
import Thumbnail from "src/components/thumbnail";
import { Asset } from "src/types/assets";
import { FileService } from "src/utils/file.service";

import _ from "lodash";
import cx from "classnames";
import styles from "./assetCard.module.scss";

interface AssetCardProps {
  asset: Asset;
}

export const AssetCard: React.FC<AssetCardProps> = ({ asset }) => {
  const fileType = useMemo(() => {
    return FileService.getFileType(asset?.metadata);
  }, [asset]);

  const readTime = useMemo(() => {
    return Math.ceil(_.get(asset, "metadata.read_time", "N/A"));
  }, [asset]);

  const fileSize = FileService.formatSize(_.get(asset, "metadata.content_length"));


  return (
    <div className={cx(styles.simpleCard)}>
      <div className={styles.wrapper}>
        <Thumbnail
          media={asset?.icon}
          defaultImage="/images/assets/default_asset.jpg"
          className={styles.icon}
        />
        <div className={styles.fileType}>
          <div className={styles.type}>{fileType}</div>
        </div>
      </div>

      <div className={styles.content}>
        <Text
          text={DOMPurify.sanitize(asset?.name, { ALLOWED_TAGS: [] })}
          tooltip={{ placement: "bottom" }}
          className={styles.name}
        />

        <div className={styles.meta}>
          <span>{fileSize}</span>
          <div className={styles.divider}></div>
          <span>
              {readTime > 0 && (
            <>
              <span className={styles.divider} />
              {`${readTime === 1 ? `${readTime} Min` : `${readTime} Mins`} Read`}
            </>
          )}
          </span>
        </div>
      </div>
    </div>
  );
};
